type DeletePostPermissionContext = {
  isAuthor: boolean;
  isEducator: boolean;
  isReadOnlyUser: boolean;
};

export const canDeletePost = ({
  isAuthor,
  isEducator,
  isReadOnlyUser,
}: DeletePostPermissionContext) => !isReadOnlyUser && (isAuthor || isEducator);
